var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnviarMensaje24X24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24/Archivo/Enviar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0034 3.10344C20.5279 2.5953 21.9782 4.04559 21.47 5.57002L16.4134 20.7398C15.8798 22.3407 13.7025 22.554 12.8684 21.0871L9.77322 15.6439C9.57304 15.2919 9.28155 15.0004 8.9295 14.8002L3.4864 11.7051C2.01946 10.871 2.23272 8.69368 3.83364 8.16004L19.0034 3.10344ZM20.047 5.09567C20.1643 4.74388 19.8296 4.4092 19.4778 4.52646L4.30798 9.58306C3.93854 9.70621 3.88932 10.2087 4.22785 10.4012L9.67095 13.4962C10.2577 13.8299 10.7435 14.3157 11.0772 14.9024L14.1723 20.3456C14.3648 20.6841 14.8672 20.6349 14.9904 20.2655L20.047 5.09567Z",
    fill: "#F07B43"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.77319 14.8007C9.4803 14.5078 9.4803 14.0329 9.77319 13.74L11.7732 11.74C12.0661 11.4471 12.541 11.4471 12.8339 11.74C13.1267 12.0329 13.1267 12.5078 12.8339 12.8007L10.8339 14.8007C10.541 15.0936 10.0661 15.0936 9.77319 14.8007Z",
    fill: "#F07B43"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnviarMensaje24X24);
export default __webpack_public_path__ + "static/media/ENVIAR_MENSAJE_24X24.714ebe5c0a95cfe384e6b737d04fa91c.svg";
export { ForwardRef as ReactComponent };